import { CountryCode } from './countryCodes'
import mapCodeToFile from './mappers/mapCodeToFile'
import i18n from '.'

export type Language =
  | 'bg'
  | 'cs'
  | 'de'
  | 'en'
  | 'es'
  | 'fr'
  | 'hu'
  | 'it'
  | 'pl'
  | 'pt'
  | 'pt_BR'
  | 'ru'
  | 'sv'
  | 'tr'
  | 'el'
  | 'fil'
  | 'ja'
  | 'ko'
  | 'ms'
  | 'th'
  | 'ro'
  | 'in'
  | 'uk'
  | 'none'

export async function changeLanguage(lng: CountryCode) {
  return await i18n.changeLanguage(lng === 'pl' ? 'pl_PL' : lng)
}

export async function loadLanguage(lng: CountryCode) {
  if (i18n.languages.includes(lng)) {
    await i18n.removeResourceBundle(lng, 'translations')
  }

  return await mapCodeToFile(lng).then(resources => {
    i18n.addResourceBundle(
      lng === 'pl' ? 'pl_PL' : lng,
      'translations',
      resources,
      true,
      false,
    )
  })
}
